<div class="status-dialog-container">
	<!-- Заголовок -->
	<div class="dialog-header">
		<h2 mat-dialog-title class="dialog-title">
			<mat-icon class="title-icon" aria-hidden="true" [class.in-action]="hasAction()">sync</mat-icon>
			Обновляем медиаплан
		</h2>
		<button mat-icon-button class="close-button" (click)="onClose()" aria-label="Закрыть">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<!-- Контент -->
	<mat-dialog-content class="dialog-content">
		<!-- Список статусов -->
		<mat-list class="status-list">
			<mat-list-item *ngFor="let item of statusItems" class="status-item">
				<div class="status-content">
					<!-- Иконка статуса -->
					<mat-icon [class]="'status-icon ' + item.status.toLowerCase()" [style.color]="item.color">
						{{ item.icon }}
					</mat-icon>

					<!-- Название устройства -->
					<div class="device-info">
						<span class="device-name">{{ item.name }}</span>
						<!-- <span class="device-uuid">({{ item.uuid }})</span> -->
					</div>

					<!-- Статус -->
					<span class="status-badge" [style.background]="item.color">
						{{ getStatusText(item.status) }}
					</span>

					<!-- Время получения -->
					<!-- <span class="timestamp">
						{{ item.receivedAt | date: 'HH:mm:ss' }}
					</span> -->
				</div>
			</mat-list-item>
		</mat-list>

		<!-- Сообщение если нет статусов -->
		<div *ngIf="statusItems.length === 0" class="no-statuses">
			<mat-icon class="no-data-icon">info</mat-icon>
			<p>Ожидание статусов проверки...</p>
		</div>

		<!-- Счетчик обновлений -->
		<!-- <div class="update-counter">
			<mat-icon class="counter-icon">refresh</mat-icon>
			<span>Обновлений получено: {{ updateCount }}</span>
		</div> -->
	</mat-dialog-content>

	<!-- Действия -->
	<mat-dialog-actions align="end" class="dialog-actions">
		<!-- <button mat-button (click)="toggleUpdates()" class="toggle-button">
			<mat-icon>{{ isUpdating ? 'pause' : 'play_arrow' }}</mat-icon>
			{{ isUpdating ? 'Приостановить' : 'Возобновить' }}
		</button> -->
		<button mat-raised-button color="primary" (click)="onClose()">Закрыть</button>
	</mat-dialog-actions>
</div>
